import { CommonModule } from '@angular/common';
/**
 * Terminus NavProfile Component v1.0.0
 */
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
@Component({
  selector: 'tux-nav-profile',
  templateUrl: './nav-profile.component.html',
  styleUrls: ['./nav-profile.component.scss'],
  imports: [CommonModule, FontAwesomeModule],
})
export class NavProfileComponent {
  @Input() initial: string;
  faCaretRight = faCaretRight;
}
